import { DateTime } from 'luxon';
import { SubjectData } from 'shell/models/person';
import { AccordionDeath as DeathDataVM } from 'shell/view-models/accordion-death';
import { transformToChoiceDate } from 'shell/components/shared/choice-date/functions';

export const transformDeath = (person: SubjectData): DeathDataVM | undefined => {
  const death = person.datiDecesso;

  const eventChoiceDate = transformToChoiceDate(death?.senzaGiorno, death?.senzaGiornoMese);

  const isDigital = Boolean(death?.attoEventoANPR?.attoANSC);

  const deathData: DeathDataVM | undefined = death
    ? {
        eventDate: death?.dataEvento ? DateTime.fromISO(death?.dataEvento) : null,
        // without day or without day and month
        eventChoiceDate,
        deathMunicipality: death?.luogoEvento?.comune?.codiceIstat
          ? {
              id: death?.luogoEvento?.comune?.codiceIstat || '',
              description: death?.luogoEvento?.comune?.nomeComune || '',
              province: death?.luogoEvento?.comune?.siglaProvinciaIstat || '',
            }
          : null,
        deathProvince: death?.luogoEvento?.comune?.siglaProvinciaIstat || '',
        deathLocation: death?.luogoEvento?.comune?.descrizioneLocalita || '',
        state: death?.luogoEvento?.localita?.codiceStato
          ? {
              id: death?.luogoEvento?.localita?.codiceStato || '',
              value: death?.luogoEvento?.localita?.descrizioneStato || '',
              province: death?.luogoEvento?.localita?.provinciaContea || '',
            }
          : null,
        stateMunicipality: death?.luogoEvento?.localita?.descrizioneLocalita
          ? {
              description: death?.luogoEvento?.localita?.descrizioneLocalita || '',
              province: death?.luogoEvento?.localita?.provinciaContea || '',
            }
          : null,
        county: death?.luogoEvento?.localita?.provinciaContea || '',
        exceptionalPlace: death?.luogoEvento?.luogoEccezionale || '',
        isDigital,
        digital: isDigital
          ? {
              documentDate: death?.attoEventoANPR?.attoANSC?.dataFormazioneAtto
                ? DateTime.fromISO(death?.attoEventoANPR?.attoANSC?.dataFormazioneAtto)
                : null,
              idAnsc: death?.attoEventoANPR?.attoANSC?.idANSC || '',
              istatCode: death?.attoEventoANPR?.attoANSC?.comuneRegistrazione?.codiceIstat || '',
              municipality: death?.attoEventoANPR?.attoANSC?.comuneRegistrazione
                ? {
                    id: death?.attoEventoANPR?.attoANSC?.comuneRegistrazione?.codiceIstat || '',
                    description:
                      death?.attoEventoANPR?.attoANSC?.comuneRegistrazione?.nomeComune || '',
                    province:
                      death?.attoEventoANPR?.attoANSC?.comuneRegistrazione?.siglaProvinciaIstat ||
                      '',
                  }
                : null,
              numberMunicipality: death?.attoEventoANPR?.attoANSC?.numeroComunale || '',
              year: death?.attoEventoANPR?.attoANSC?.anno || '',
              transcript: death?.attoEventoANPR?.attoANSC?.trascritto === '1' ? true : false,
            }
          : undefined,
        // paper
        municipality: death?.attoEventoANPR?.atto?.comuneRegistrazione?.codiceIstat
          ? {
              id: death?.attoEventoANPR?.atto?.comuneRegistrazione?.codiceIstat || '',
              description: death?.attoEventoANPR?.atto?.comuneRegistrazione?.nomeComune || '',
              province: death?.attoEventoANPR?.atto?.comuneRegistrazione?.siglaProvinciaIstat || '',
            }
          : null,
        istatCode: death?.attoEventoANPR?.atto?.comuneRegistrazione?.codiceIstat || '',
        province: death?.attoEventoANPR?.atto?.comuneRegistrazione?.siglaProvinciaIstat || '',
        location: death?.attoEventoANPR?.atto?.comuneRegistrazione?.descrizioneLocalita || '',
        towhHallOffice: death?.attoEventoANPR?.atto?.ufficioMunicipio || '',
        year: death?.attoEventoANPR?.atto?.anno || '',
        documentNumber: death?.attoEventoANPR?.atto?.numeroAtto || '',
        portion: death?.attoEventoANPR?.atto?.parte || '',
        range: death?.attoEventoANPR?.atto?.serie || '',
        regVol: death?.attoEventoANPR?.atto?.volume || '',
        documentDate: death?.attoEventoANPR?.atto?.dataFormazioneAtto
          ? DateTime.fromISO(death?.attoEventoANPR?.atto?.dataFormazioneAtto)
          : null,
        transcript: death?.attoEventoANPR?.atto?.trascritto === '1' ? true : false,
        isForeign: !!death?.luogoEvento?.localita,
      }
    : undefined;

  return deathData;
};
